import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

//Bootstrap
import { Form, Row, Col } from "react-bootstrap";

//UI components
import FormFieldCurrency from "../../../ui/FormFieldCurrency";
import FormField from "../../../ui/FormField";
import ErrorMessage from "../../../ui/ErrorMessage";

//Validation schema
import formEditClaniceFinanceSchema from "../../../../config/formEditClaniceFinanceNacrtovano";

//API calls
import { useEditNacrtovaneVrednostiProjektaClanice } from "../../../../services/ProjectDetails/financeAPI";

const EditFormClaniceNacrtovano = ({ clanica, setIsEditing }) => {
  const { id } = useParams();
  const schema = useMemo(() => formEditClaniceFinanceSchema, []);

  //PUT edit nacrtovane vrednosti clanice
  const {
    mutate: editNacrtovaneVrednostiClanice,
    isPending: isPendingEdit,
    isError,
    error,
    reset: resetMutationError,
  } = useEditNacrtovaneVrednostiProjektaClanice(id);

  const {
    handleSubmit,
    register,
    formState: { errors, isDirty },
    control,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      nacrtovanaVrednost: clanica?.nacrtovanaVrednost,
      nacrtovanaLastnaVrednost: clanica?.nacrtovanaLastnaVrednost,
      nacrtovanaVrednostViri: clanica?.nacrtovanaVrednostViri,
      nacrtovaniObseg: clanica?.nacrtovaniObseg,
    },
  });

  const onSubmit = (data) => {
    const payload = {
      clanicaID: clanica.clanicaID,
      nacrtovanaVrednost: data?.nacrtovanaVrednost,
      nacrtovanaLastnaVrednost: data?.nacrtovanaLastnaVrednost,
      nacrtovanaVrednostViri: data?.nacrtovanaVrednostViri,
      nacrtovaniObseg: data?.nacrtovaniObseg,
    };

    editNacrtovaneVrednostiClanice(payload, {
      onSuccess: () => {
        setIsEditing(false);
      },
      onError: () => setTimeout(() => resetMutationError(), 3000),
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Row>
        <Col md={6}>
          <FormFieldCurrency
            label="Vrednost projekta"
            name="nacrtovanaVrednost"
            control={control}
            validationError={errors.nacrtovanaVrednost?.message}
          />
          <FormFieldCurrency
            label="Lastno sofinanciranje"
            name="nacrtovanaLastnaVrednost"
            control={control}
            validationError={errors.nacrtovanaLastnaVrednost?.message}
          />
        </Col>
        <Col md={6}>
          <FormFieldCurrency
            label="Sofinanciranje iz projektnega vira"
            name="nacrtovanaVrednostViri"
            control={control}
            validationError={errors.nacrtovanaVrednostViri?.message}
          />
          <FormField
            label="Obseg zaposlitev (FTE)"
            formControlType="number"
            register={register("nacrtovaniObseg", { valueAsNumber: true })}
            validationError={errors.nacrtovaniObseg?.message}
            min={0}
            step={0.1}
          />
        </Col>
      </Row>
      <button
        type="submit"
        className="btn btn-primary mt-3"
        disabled={!isDirty || isPendingEdit}
      >
        {isPendingEdit ? "Shranjevanje..." : "Shrani"}
      </button>
      <button
        type="button"
        className="btn btn-secondary mt-3 ms-2"
        onClick={() => setIsEditing(false)}
      >
        Prekliči
      </button>
      {isError && <ErrorMessage message={error.message} />}
    </Form>
  );
};

export default EditFormClaniceNacrtovano;
